export interface LayoutState {
  showLeftSidenav: boolean;
  showRightSidenav: boolean;
}

export const initialLayoutState: LayoutState = {
  showLeftSidenav: false,
  showRightSidenav: false,
}
